import React, { useEffect, useState } from "react";
import { Container, InfoTag, AssociateInfo, Label } from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import { format, subDays } from "date-fns";
import {
  DatePicker,
  Spin,
  Progress,
  Button,
  Modal,
  Pagination,
  Input,
  Select,
  Tabs,
  Tooltip,
} from "antd";
import {
  MdAttachMoney,
  MdPeopleOutline,
  MdCheckCircleOutline,
  MdTrendingUp,
  MdSearch,
  MdInsights,
  MdTimer,
  MdAutoGraph,
  MdHelpOutline,
  MdAdd,
  MdAccountBalanceWallet,
  MdReceipt,
  MdEdit,
  MdPersonOutline,
  MdPhone,
  MdVisibility,
  MdClose,
  MdMail,
  MdLocationOn,
  MdBusiness,
  MdGroup,
  MdAssignment,
  MdArrowBack,
} from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import dayjs from "dayjs";
import userPhoto from "../../../images/user.png";
import { getValue, phoneFormat } from "../../../services/functions";
import {
  ViewInput,
  Table,
  Scroll,
  Message,
  InputTel,
  Card,
} from "../../../GlobalStyles";
import { toast } from "react-toastify";
import IntlCurrencyInput from "react-intl-currency-input";
import { currencyConfig } from "../../../services/states";
import CountUp from "react-countup";
import Status from "../../../components/status";

const { RangePicker } = DatePicker;
const { Option } = Select;
const { TextArea } = Input;
const { TabPane } = Tabs;

const statusesList = [
  "Pendente",
  "Oportunidade",
  "Abordagem",
  "Atendimento",
  "Qualificação",
  "Proposta Enviada",
  "Negociação",
  "Cliente Perdido",
  "Cliente Fechado",
];

const statusColors = {
  Pendente: "#999",
  Oportunidade: "#1890ff",
  Abordagem: "#722ed1",
  Atendimento: "#eb2f96",
  Qualificação: "#2f54eb",
  "Proposta Enviada": "#fa8c16",
  Negociação: "#faad14",
  "Cliente Perdido": "#f5222d",
  "Cliente Fechado": "#008037",
};

export default function AssociadoDetailsAdmin() {
  const { id } = useParams();
  const navigate = useNavigate();

  // Navigation state
  const [activeTab, setActiveTab] = useState("1");
  const [associate, setAssociate] = useState({});

  // Dashboard states
  const [stats, setStats] = useState([]);
  const [isLoadingDashboard, setIsLoadingDashboard] = useState(true);
  const [resume, setResume] = useState({});

  const [dateStartDashboard, setDateStartDashboard] = useState(
    subDays(new Date(), 30),
  );
  const [dateEndDashboard, setDateEndDashboard] = useState(new Date());

  // Leads list states
  const [leads, setLeads] = useState([]);
  const [leadsTotal, setLeadsTotal] = useState(0);
  const [isLoadingLeads, setIsLoadingLeads] = useState(true);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [dateStartLeads, setDateStartLeads] = useState(null);
  const [dateEndLeads, setDateEndLeads] = useState(null);

  // Payments list states
  const [payments, setPayments] = useState([]);
  const [paymentsTotal, setPaymentsTotal] = useState(0);
  const [paymentsTotalValue, setPaymentsTotalValue] = useState(0);
  const [pagePayments, setPagePayments] = useState(0);
  const [isLoadingPayments, setIsLoadingPayments] = useState(true);

  // Modals states
  const [isLeadModalOpen, setIsLeadModalOpen] = useState(false);
  const [isViewLeadModalOpen, setIsViewLeadModalOpen] = useState(false);
  const [leadSelected, setLeadSelected] = useState({});
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);

  // Lead Form states
  const [leadId, setLeadId] = useState(null);
  const [leadName, setLeadName] = useState("");
  const [leadEmail, setLeadEmail] = useState("");
  const [leadPhone, setLeadPhone] = useState("");
  const [leadNecessity, setLeadNecessity] = useState("");
  const [leadEmployees, setLeadEmployees] = useState("");
  const [leadLocation, setLeadLocation] = useState("");
  const [leadCnpj, setLeadCnpj] = useState("");
  const [leadObservation, setLeadObservation] = useState("");

  const [paymentValue, setPaymentValue] = useState(0);
  const [paymentDescription, setPaymentDescription] = useState("");

  const getStatusClass = (status) => {
    const s = status || "";
    if (s.includes("Oportunidade")) return "oportunidade";
    if (s.includes("Atendimento") || s.includes("Abordagem"))
      return "atendimento";
    if (s.includes("Cliente Fechado")) return "fechado";
    if (s.includes("Cliente Perdido")) return "perdido";
    return "default";
  };

  useEffect(() => {
    loadDashboard();
  }, [id, dateStartDashboard, dateEndDashboard]);

  useEffect(() => {
    loadLeads();
  }, [id, page, statusFilter, dateStartLeads, dateEndLeads]);

  useEffect(() => {
    loadPayments();
  }, [id, pagePayments]);

  async function loadDashboard() {
    setIsLoadingDashboard(true);
    await api
      .get(
        `/resume/associate/${id}?startDate=${dateStartDashboard}&endDate=${dateEndDashboard}`,
      )
      .then((response) => {
        const resume = response.data;
        setResume(resume);

        setAssociate(resume.associate);
        setStats([
          { name: "Pendente", value: resume.totalLeadsPendente, color: "#999" },
          { name: "Oportunidade", value: resume.totalLeadsOportunidade },
          { name: "Abordagem", value: resume.totalLeadsAbordagem },
          { name: "Atendimento", value: resume.totalLeadsAtendimento },
          { name: "Qualificação", value: resume.totalLeadsQualificacao },
          { name: "Proposta Enviada", value: resume.totalLeadsPropostaEnviada },
          { name: "Negociação", value: resume.totalLeadsNegociacao },
          {
            name: "Cliente Perdido",
            value: resume.totalLeadsClientePerdido,
            color: "#f44336",
          },
          {
            name: "Cliente Fechado",
            value: resume.totalLeadsClienteFechado,
            color: "#008037",
          },
        ]);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingDashboard(false);
  }

  async function loadLeads() {
    setIsLoadingLeads(true);

    const params = {
      page: page,
    };
    if (dateStartLeads && dateEndLeads) {
      params.dateStart = format(dateStartLeads, "yyyy-MM-dd");
      params.dateEnd = format(dateEndLeads, "yyyy-MM-dd");
    }
    if (search) {
      params.search = search;
    }
    if (statusFilter) {
      params.status = statusFilter;
    }

    await api
      .get(`/leads/associate/${id}`, { params })
      .then((response) => {
        let leads = response.data.leads || [];
        leads.map((item) => {
          if (item.contracts) {
            item.contracts.map((data) => {
              item.valueContract = 0;
              if (data.services) {
                data.services.map((service) => {
                  item.valueContract += service.amount * service.value;
                });
              }
              if (data.service_value) {
                item.valueContract += data.service_value;
              }
              if (data.discount) {
                item.valueContract -= data.discount;
              }
            });
            item.completedValue = item.contracts.reduce((total, contract) => {
              return contract.status === "assinado"
                ? total + (item.valueContract || 0)
                : total;
            }, 0);
            item.lostValue = item.contracts.reduce((total, contract) => {
              return contract.status === "expirado" ||
                contract.status === "recusado"
                ? total + (item.valueContract || 0)
                : total;
            }, 0);
          } else {
            item.completedValue = 0;
            item.lostValue = 0;
          }
        });

        setLeads(leads);
        setLeadsTotal(response.data.total || 0);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });

    setIsLoadingLeads(false);
  }

  async function loadPayments() {
    setIsLoadingPayments(true);
    await api
      .get(`/payments/associate/${id}?page=${pagePayments}`)
      .then((response) => {
        setPayments(response.data.payments);
        setPaymentsTotal(response.data.paymentsTotal);
        setPaymentsTotalValue(response.data.paymentsTotalValue);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingPayments(false);
  }

  async function handleSaveLead() {
    if (!leadName || !leadEmail || !leadPhone) {
      return toast.warn(
        "Preencha os campos obrigatórios (Nome, E-mail e Telefone)",
      );
    }
    setIsLoadingModal(true);
    const data = {
      name: leadName,
      email: leadEmail,
      phone_number: leadPhone,
      necessity: leadNecessity,
      employees: leadEmployees,
      location: leadLocation,
      cnpj: leadCnpj,
      observation: leadObservation,
      associate_id: id,
    };

    if (leadId) {
      await api
        .put(`/lead/master/${leadId}`, data)
        .then((response) => {
          loadLeads();
          loadDashboard();
          setIsLeadModalOpen(false);
          clearLeadFields();
          toast.success("Lead editado com sucesso!");
        })
        .catch(({ response }) => {
          if (response?.data?.message) {
            toast.warn(response.data.message);
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        });
    } else {
      await api
        .post(`/lead/master`, data)
        .then((response) => {
          loadLeads();
          loadDashboard();
          setIsLeadModalOpen(false);
          clearLeadFields();
          toast.success("Lead editado com sucesso!");
        })
        .catch(({ response }) => {
          if (response?.data?.message) {
            toast.warn(response?.data?.message);
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        });
    }
    setIsLoadingModal(false);
  }

  async function handleRegisterPayment() {
    if (!paymentValue) {
      return toast.warn("Preencha o valor do pagamento");
    }
    setIsLoadingModal(true);
    await api
      .post(`/payment/associate`, {
        value: paymentValue,
        associate_id: id,
        description: paymentDescription,
      })
      .then((response) => {
        toast.success("Pagamento registrado com sucesso!");
        setIsPaymentModalOpen(false);
        setPaymentValue(0);
        setPaymentDescription("");
        loadPayments();
        loadDashboard();
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response?.data?.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingModal(false);
  }

  function handleStatusClick(status) {
    setStatusFilter(status);
    setPage(0);
    setActiveTab("2");
  }

  function clearLeadFields() {
    setLeadId(null);
    setLeadName("");
    setLeadEmail("");
    setLeadPhone("");
    setLeadNecessity("");
    setLeadEmployees("");
    setLeadLocation("");
    setLeadCnpj("");
    setLeadObservation("");
  }

  return (
    <Container>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 15,
          marginBottom: 20,
        }}
      >
        <Button
          shape="circle"
          icon={<MdArrowBack size={20} />}
          onClick={() => navigate("/admin/associados")}
        />
        <h1>Detalhes associado</h1>
      </div>
      <div className="profile-header-container">
        <div className="photo-card">
          <div className="photo-container">
            <img
              src={associate?.photo ? associate.photo_url : userPhoto}
              alt={associate?.name}
            />
          </div>
          <div style={{ textAlign: "center" }}>
            <h3>{associate?.name}</h3>
            <p>Perfil de Associado</p>
          </div>
        </div>

        <div className="info-card">
          <div className="card-header-actions">
            <div className="section-title">
              <MdPersonOutline size={20} />
              Informações Pessoais
            </div>

            <div className="actions-profile">
              <button
                className="primary-btn"
                onClick={() => setIsLeadModalOpen(true)}
              >
                <MdAdd size={20} /> Adicionar Lead
              </button>
              <button
                className="primary-btn"
                onClick={() => setIsPaymentModalOpen(true)}
              >
                <MdAccountBalanceWallet size={20} /> Registrar Pagamento
              </button>
            </div>
          </div>

          <div className="info-grid-profile">
            <div className="info-item">
              <label>Nome Completo</label>
              <span>{associate?.name || "---"}</span>
            </div>
            <div className="info-item">
              <label>E-mail Corporativo</label>
              <span>{associate?.email || "---"}</span>
            </div>
            <div className="info-item">
              <label>Telefone / WhatsApp</label>
              <span>
                {associate?.phone_number
                  ? phoneFormat(associate.phone_number)
                  : "---"}
              </span>
            </div>
            <div className="info-item">
              <label>CPF</label>
              <span>{associate?.cpf || "---"}</span>
            </div>
            <div className="info-item">
              <label>CNPJ</label>
              <span>{associate?.cnpj || "---"}</span>
            </div>
            <div className="info-item">
              <label>Cidade / Estado</label>
              <span>
                {associate?.city && associate?.state
                  ? `${associate.city} - ${associate.state}`
                  : "---"}
              </span>
            </div>
            <div className="info-item">
              <label>Taxa de Comissão</label>
              <span style={{ color: "#008037" }}>
                {associate?.comission || 0}%
              </span>
            </div>
            <div className="info-item">
              <label>Franqueado Responsável</label>
              <span>{associate?.user?.name || "Direto da Matriz"}</span>
            </div>
            <div className="info-item">
              <label>Status da Conta</label>
              <span style={{ color: "#008037" }}>Ativo</span>
            </div>
          </div>

          <div className="section-title" style={{ margin: "15px 0" }}>
            <MdAccountBalanceWallet size={20} />
            Dados de Pagamento (PIX)
          </div>

          <div className="info-grid-profile">
            <div className="info-item">
              <label>Tipo de Chave</label>
              <span>{associate?.type_pix || "Não configurado"}</span>
            </div>
            <div className="info-item">
              <label>Chave PIX</label>
              <span>{associate?.key_pix || "Não configurada"}</span>
            </div>
          </div>
        </div>
      </div>

      <Tabs activeKey={activeTab} onChange={(key) => setActiveTab(key)}>
        <TabPane tab={<span>Relatório</span>} key="1">
          <div className="dashboard-header">
            <h2 className="section-title-dash">Dados Gerais</h2>
            <ViewInput style={{ width: 280 }}>
              <p>Filtrar por Período</p>
              <RangePicker
                style={{ width: "100%" }}
                value={[dayjs(dateStartDashboard), dayjs(dateEndDashboard)]}
                format={"DD/MM/YYYY"}
                onChange={(dates) => {
                  if (dates) {
                    setDateStartDashboard(dates[0].toDate());
                    setDateEndDashboard(dates[1].toDate());
                  }
                }}
                allowClear={false}
              />
            </ViewInput>
          </div>

          {isLoadingDashboard ? (
            <div
              style={{ display: "flex", justifyContent: "center", padding: 50 }}
            >
              <Spin size="large" color="#008037" />
            </div>
          ) : (
            <>
              <div className="main-tags">
                <div className="tag-item highlight">
                  <div className="tag-header">
                    <MdAttachMoney size={20} /> Total de pagamentos
                  </div>
                  <span className="value">
                    {getValue(resume?.totalPaymentsValue || 0)}
                  </span>
                </div>
                <div className="tag-item">
                  <div className="tag-header">
                    <MdPeopleOutline size={20} /> Total de Leads Cadastrados
                  </div>
                  <span className="value">
                    {resume?.totalLeadsCreated || 0}
                  </span>
                </div>
                <div className="tag-item warning">
                  <div className="tag-header">
                    <MdCheckCircleOutline size={20} /> Sua Taxa de Comissão
                  </div>
                  <span className="value">{associate?.comission || 0}%</span>
                </div>
              </div>

              <h2 className="section-title-dash">Desempenho no Período</h2>
              <div className="main-tags">
                <div className="tag-item highlight">
                  <div className="tag-header">
                    <MdAttachMoney size={20} /> Comissões Recebidas no Período
                  </div>
                  <span className="value">
                    {getValue(resume?.totalLeadsClienteFechadoValue || 0)}
                  </span>
                </div>
                <div className="tag-item">
                  <div className="tag-header">
                    <MdPeopleOutline size={20} /> Leads Cadastrados no Período
                  </div>
                  <span className="value">
                    {resume?.leadsPeriodCreated || 0}
                  </span>
                </div>
                <div className="tag-item warning">
                  <div className="tag-header">
                    <MdTrendingUp size={20} /> Valor em Negociação no Período
                  </div>
                  <span className="value">
                    {getValue(resume?.totalLeadsPotentialValue || 0)}
                  </span>
                </div>
              </div>
              <h2 className="section-title-dash">Acompanhamento de Status</h2>
              <div className="status-grid">
                {stats.map((item, index) => (
                  <div
                    className="status-tag"
                    key={index}
                    style={{
                      borderLeft: `4px solid ${item.color || "#008037"}`,
                      "--color": item.color || "#008037",
                    }}
                    onClick={() => handleStatusClick(item.name)}
                  >
                    <span className="label">{item.name}</span>
                    <span className="count">{item.value}</span>
                  </div>
                ))}
              </div>
              <div className="main-stats">
                <div className="insight-card">
                  <div className="icon-wrapper green">
                    <MdTrendingUp size={24} />
                  </div>
                  <label>Média por Venda</label>
                  <div className="value-row">
                    <h3>
                      {getValue(
                        resume?.totalLeadsClienteFechadoValue /
                          resume?.totalLeadsClienteFechado || 0,
                      )}
                    </h3>
                  </div>
                  <div className="footer-info">
                    <MdInsights size={14} />
                    Sua comissão média por cada fechamento
                  </div>
                </div>

                <div className="insight-card">
                  <div className="icon-wrapper blue">
                    <MdTimer size={24} />
                  </div>
                  <label>Em Andamento</label>
                  <div className="value-row">
                    <h3>
                      {(resume.totalLeadsOportunidade || 0) +
                        (resume.totalLeadsAbordagem || 0) +
                        (resume.totalLeadsAtendimento || 0) +
                        (resume.totalLeadsQualificacao || 0) +
                        (resume.totalLeadsPropostaEnviada || 0) +
                        (resume.totalLeadsNegociacao || 0)}
                    </h3>
                    <span className="unit">Leads</span>
                  </div>
                  <div className="footer-info">
                    <MdPeopleOutline size={14} />
                    Leads sendo trabalhados no momento
                  </div>
                </div>

                <div className="insight-card conversion-insight">
                  <div className="icon-wrapper orange">
                    <MdAutoGraph size={24} />
                  </div>
                  <label>Aproveitamento</label>
                  <div className="value-row">
                    <h3>
                      {(
                        (resume.totalLeadsClienteFechado /
                          (resume.totalLeadsClienteFechado +
                            resume.totalLeadsClientePerdido)) *
                          100 || 0
                      ).toFixed(1)}
                    </h3>
                    <span className="unit">%</span>
                  </div>
                  <div className="progress-container">
                    <Progress
                      percent={
                        (resume.totalLeadsClienteFechado /
                          (resume.totalLeadsClienteFechado +
                            resume.totalLeadsClientePerdido)) *
                          100 || 0
                      }
                      showInfo={false}
                      strokeColor="#f2760a"
                      strokeWidth={8}
                    />
                  </div>
                  <div className="footer-info">
                    <MdInsights size={14} />
                    Taxa de conversão real
                  </div>
                </div>
              </div>
            </>
          )}
        </TabPane>

        <TabPane
          tab={
            <span>
              Leads <span className="count-badge">{leadsTotal}</span>
            </span>
          }
          key="2"
        >
          <div className="filters">
            <ViewInput style={{ width: 220 }}>
              <p>Status</p>
              <Select
                style={{ width: "100%" }}
                value={statusFilter}
                onChange={(value) => {
                  setStatusFilter(value);
                  setPage(0);
                }}
              >
                <Option value="">Todos</Option>
                {statusesList.map((s) => (
                  <Option key={s} value={s}>
                    {s}
                  </Option>
                ))}
              </Select>
            </ViewInput>

            <ViewInput style={{ width: 220 }}>
              <p>Buscar</p>
              <Input
                placeholder="Nome ou e-mail"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onPressEnter={() => {
                  setPage(0);
                  loadLeads();
                }}
                suffix={
                  <MdSearch
                    size={20}
                    color="#999"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setPage(0);
                      loadLeads();
                    }}
                  />
                }
              />
            </ViewInput>

            <ViewInput style={{ width: 280 }}>
              <p>Filtrar por Período de Cadastro</p>
              <RangePicker
                style={{ width: "100%" }}
                value={
                  dateStartLeads
                    ? [dayjs(dateStartLeads), dayjs(dateEndLeads)]
                    : null
                }
                format={"DD/MM/YYYY"}
                onChange={(dates) => {
                  if (dates) {
                    setDateStartLeads(dates[0].toDate());
                    setDateEndLeads(dates[1].toDate());
                  } else {
                    setDateStartLeads(null);
                    setDateEndLeads(null);
                  }
                  setPage(0);
                }}
              />
            </ViewInput>
          </div>

          <h2 className="section-title-dash">Leads</h2>
          {!isLoadingLeads ? (
            <>
              {leads.length > 0 ? (
                <div className="leads-list">
                  {leads.map((lead) => (
                    <div className="lead-card" key={lead.id}>
                      <div className="main-info">
                        <strong>{lead.name}</strong>
                        <span>{lead.email || "Sem e-mail cadastrado"}</span>
                      </div>

                      <div className="contact-info">
                        <MdPhone size={16} />
                        {lead.phone_number.replace(
                          /(\d{2})(\d{5})(\d{4})/,
                          "($1) $2-$3",
                        )}
                      </div>

                      <div className="date-info">
                        <label>Cadastro em</label>
                        {format(
                          new Date(lead.create_at || new Date()),
                          "dd/MM/yyyy",
                        )}
                      </div>

                      <div>
                        <div
                          className={`status-badge ${getStatusClass(lead?.leads?.[0]?.status || "Pendente")}`}
                        >
                          {lead?.leads?.[0]?.status || "Pendente"}
                        </div>
                      </div>

                      <div
                        className={`value-info ${getStatusClass(lead?.leads?.[0]?.status || "Pendente")}`}
                      >
                        <strong>{getValue(lead.leads?.[0]?.value || 0)}</strong>
                        <span>
                          Comissão:{" "}
                          {getValue(
                            (lead.leads?.[0]?.value * associate.comission) /
                              100 || 0,
                          )}
                        </span>
                      </div>

                      <div className="actions">
                        <Tooltip title="Ver Detalhes">
                          <Button
                            shape="circle"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            icon={<MdVisibility size={18} />}
                            onClick={() => {
                              setLeadSelected(lead);
                              setIsViewLeadModalOpen(true);
                            }}
                          />
                        </Tooltip>
                        <Tooltip title="Editar">
                          <Button
                            shape="circle"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            icon={<MdEdit size={18} />}
                            onClick={() => {
                              setLeadId(lead.id);
                              setLeadName(lead.name);
                              setLeadEmail(lead.email);
                              setLeadPhone(lead.phone_number);
                              setLeadNecessity(lead.necessity);
                              setLeadEmployees(lead.employees);
                              setLeadLocation(lead.location);
                              setLeadCnpj(lead.cnpj);
                              setLeadObservation(lead.observation);
                              setIsLeadModalOpen(true);
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  ))}

                  <Pagination
                    style={{ margin: "30px 0", alignSelf: "center" }}
                    current={page + 1}
                    total={leadsTotal}
                    pageSize={10}
                    onChange={(p) => setPage(p - 1)}
                  />
                </div>
              ) : (
                <div
                  style={{
                    background: "#fff",
                    padding: 50,
                    borderRadius: 15,
                    textAlign: "center",
                    border: "1px solid #eee",
                  }}
                >
                  <MdPeopleOutline
                    size={50}
                    color="#ccc"
                    style={{ marginBottom: 15 }}
                  />
                  <Message>
                    Nenhum lead encontrado com os filtros aplicados.
                  </Message>
                </div>
              )}
            </>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: 100,
              }}
            >
              <Spin size="large" color="#008037" />
            </div>
          )}
        </TabPane>

        <TabPane
          tab={
            <span>
              Pagamentos <span className="count-badge">{paymentsTotal}</span>
            </span>
          }
          key="3"
        >
          {isLoadingPayments ? (
            <div
              style={{ display: "flex", justifyContent: "center", padding: 50 }}
            >
              <Spin size="large" color="#008037" />
            </div>
          ) : (
            <>
              <div className="main-tags">
                <div className="tag-item highlight">
                  <div className="tag-header">
                    <MdAttachMoney size={20} /> Total Já Recebido
                  </div>
                  <span className="value">{getValue(paymentsTotalValue)}</span>
                </div>
              </div>
              <h2 className="section-title-dash">Pagamentos</h2>
              {payments.length > 0 ? (
                <div className="payments-list">
                  {payments.map((payment) => (
                    <div className="payment-card" key={payment.id}>
                      <div className="main-info">
                        <strong>{payment.description}</strong>
                        <span>Pagamento via PIX</span>
                      </div>

                      <div className="date-info">
                        <label>Recebido em</label>
                        {format(new Date(payment.create_at), "dd/MM/yyyy")}
                      </div>

                      <div>
                        <div className="status-badge-payment">Pago</div>
                      </div>

                      <div className="payment-value">
                        {getValue(payment.value)}
                      </div>
                    </div>
                  ))}

                  <Pagination
                    style={{
                      margin: "30px 0",
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                    }}
                    current={pagePayments + 1}
                    total={paymentsTotal}
                    pageSize={10}
                    onChange={(p) => setPagePayments(p - 1)}
                  />
                </div>
              ) : (
                <div
                  style={{
                    background: "#fff",
                    padding: 50,
                    borderRadius: 15,
                    textAlign: "center",
                    border: "1px solid #eee",
                  }}
                >
                  <MdReceipt
                    size={50}
                    color="#ccc"
                    style={{ marginBottom: 15 }}
                  />
                  <Message>
                    Nenhum pagamento encontrado para este associado.
                  </Message>
                </div>
              )}
            </>
          )}
        </TabPane>
      </Tabs>

      <Modal
        title={leadId ? "Editar Lead" : "Adicionar Novo Lead"}
        open={isLeadModalOpen}
        onOk={handleSaveLead}
        onCancel={() => {
          setIsLeadModalOpen(false);
          clearLeadFields();
        }}
        confirmLoading={isLoadingModal}
        okText={leadId ? "Salvar" : "Adicionar"}
        cancelText="Cancelar"
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            marginTop: 20,
          }}
        >
          <ViewInput style={{ width: "48%" }}>
            <p>Nome Completo*</p>
            <Input
              value={leadName}
              onChange={(e) => setLeadName(e.target.value)}
              placeholder="Nome do lead"
            />
          </ViewInput>
          <ViewInput style={{ width: "48%" }}>
            <p>E-mail*</p>
            <Input
              value={leadEmail}
              onChange={(e) => setLeadEmail(e.target.value)}
              placeholder="email@exemplo.com"
            />
          </ViewInput>
          <ViewInput style={{ width: "48%" }}>
            <p>Telefone*</p>
            <InputTel
              mask="(99) 99999-9999"
              maskChar=""
              value={leadPhone}
              placeholder="(00) 00000-0000"
              onChange={(e) =>
                setLeadPhone(e.target.value.replace(/[^0-9]/g, ""))
              }
            />
          </ViewInput>
          <ViewInput style={{ width: "48%" }}>
            <p>Necessidade</p>
            <Input
              value={leadNecessity}
              onChange={(e) => setLeadNecessity(e.target.value)}
              placeholder="O que o cliente busca?"
            />
          </ViewInput>
          <ViewInput style={{ width: "48%" }}>
            <p>Funcionários</p>
            <Input
              value={leadEmployees}
              onChange={(e) => setLeadEmployees(e.target.value)}
              placeholder="Qtd. funcionários"
            />
          </ViewInput>
          <ViewInput style={{ width: "48%" }}>
            <p>Localização</p>
            <Input
              value={leadLocation}
              onChange={(e) => setLeadLocation(e.target.value)}
              placeholder="Cidade/Estado"
            />
          </ViewInput>
          <ViewInput style={{ width: "100%" }}>
            <p>CNPJ</p>
            <Input
              value={leadCnpj}
              onChange={(e) => setLeadCnpj(e.target.value)}
              placeholder="00.000.000/0000-00"
            />
          </ViewInput>
          <ViewInput style={{ width: "100%" }}>
            <p>Observações</p>
            <TextArea
              rows={4}
              value={leadObservation}
              onChange={(e) => setLeadObservation(e.target.value)}
              placeholder="Detalhes adicionais..."
            />
          </ViewInput>
        </div>
      </Modal>

      <Modal
        open={isViewLeadModalOpen}
        onCancel={() => setIsViewLeadModalOpen(false)}
        footer={null}
        closable={false}
        styles={{ content: { padding: 0 } }}
      >
        <div
          style={{
            position: "relative",
            background: "#fff",
            borderRadius: 5,
            padding: "25px 20px 20px 20px",
            borderTop: "30px solid #d7f0db",
          }}
        >
          <MdClose
            style={{
              position: "absolute",
              cursor: "pointer",
              top: -25,
              right: 10,
            }}
            size={20}
            color="#333"
            onClick={() => setIsViewLeadModalOpen(false)}
          />
          <header
            style={{
              position: "absolute",
              top: -22,
              left: 15,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Label color={"#008037"} />
            <p
              style={{
                marginLeft: 5,
                fontSize: 12,
                fontWeight: 500,
                color: "#000a",
              }}
            >
              Detalhes do Lead
            </p>
          </header>

          <h2 style={{ marginTop: 10, fontSize: 22 }}>{leadSelected.name}</h2>

          <InfoTag>
            {leadSelected.email && (
              <div className="tag">
                <MdMail size={14} /> {leadSelected.email}
              </div>
            )}
            {leadSelected.phone_number && (
              <div className="tag">
                <MdPhone size={14} /> {leadSelected.phone_number}
              </div>
            )}
            {leadSelected.location && (
              <div className="tag">
                <MdLocationOn size={14} /> {leadSelected.location}
              </div>
            )}
            {leadSelected.cnpj && (
              <div className="tag">
                <MdBusiness size={14} /> CNPJ: {leadSelected.cnpj}
              </div>
            )}
            {leadSelected.employees && (
              <div className="tag">
                <MdGroup size={14} /> {leadSelected.employees} func.
              </div>
            )}
            {leadSelected.necessity && (
              <div className="tag">
                <MdAssignment size={14} /> {leadSelected.necessity}
              </div>
            )}
          </InfoTag>

          <div style={{ margin: "15px 0" }}>
            <p style={{ fontSize: 13, color: "#666", marginBottom: 5 }}>
              Observações do Cadastro:
            </p>
            <p style={{ fontSize: 14, fontWeight: "normal", color: "#333" }}>
              {leadSelected.observation || "Sem observações adicionais."}
            </p>
          </div>

          <p
            style={{
              fontSize: 18,
              color: "#008037",
              fontWeight: "bold",
              margin: 0,
            }}
          >
            {getValue(leadSelected?.leads?.[0]?.value || 0)}
          </p>
          <div
            style={{
              background: "#f9f9f9",
              padding: 15,
              borderRadius: 10,
              margin: "15px 0",
            }}
          >
            <p style={{ fontSize: 12, color: "#888", margin: 0 }}>
              Valor da Comissão:
            </p>
            <p
              style={{
                fontSize: 20,
                color: "#008037",
                fontWeight: "bold",
                margin: 0,
              }}
            >
              {getValue(
                leadSelected?.leads?.[0]?.value * (associate.comission / 100) ||
                  0,
              )}
            </p>
          </div>

          <div style={{ display: "flex", gap: 15, marginTop: 10 }}>
            {leadSelected.phone_number && (
              <FaWhatsapp
                size={22}
                color="#25D366"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  window.open(
                    `https://api.whatsapp.com/send/?phone=55${leadSelected.phone_number}`,
                  )
                }
              />
            )}
            {leadSelected.phone_number && (
              <MdPhone
                size={22}
                color="#333"
                style={{ cursor: "pointer" }}
                onClick={() => window.open(`tel:${leadSelected.phone_number}`)}
              />
            )}
            {leadSelected.email && (
              <MdMail
                size={22}
                color="#EA4335"
                style={{ cursor: "pointer" }}
                onClick={() => window.open(`mailto:${leadSelected.email}`)}
              />
            )}
          </div>

          <AssociateInfo>
            <img
              src={associate.photo ? associate?.photo_url : userPhoto}
              alt="Perfil"
            />
            <div className="info">
              <span>Cadastrado por:</span>
              <strong>{associate?.name}</strong>
            </div>
          </AssociateInfo>

          {leadSelected?.leads?.[0]?.user && (
            <AssociateInfo>
              <img
                src={
                  leadSelected?.leads?.[0]?.user?.photo
                    ? leadSelected?.leads?.[0]?.user?.photo_url
                    : userPhoto
                }
                alt="Perfil"
              />
              <div className="info">
                <span>Franqueado responsável:</span>
                <strong>{leadSelected?.leads?.[0]?.user?.name}</strong>
              </div>
            </AssociateInfo>
          )}
        </div>
      </Modal>

      <Modal
        title="Registrar Pagamento ao Associado"
        open={isPaymentModalOpen}
        onOk={handleRegisterPayment}
        onCancel={() => setIsPaymentModalOpen(false)}
        confirmLoading={isLoadingModal}
        okText="Registrar"
        cancelText="Cancelar"
      >
        <div style={{ marginTop: 20 }}>
          <ViewInput>
            <p>Valor do Pagamento*</p>
            <IntlCurrencyInput
              style={{
                width: "100%",
                backgroundColor: "#FFF",
                borderWidth: 1,
                borderColor: "#ccc",
                borderStyle: "solid",
                color: "#000",
                padding: "8px 12px",
                fontSize: 14,
                borderRadius: 4,
              }}
              currency="BRL"
              config={currencyConfig}
              value={paymentValue}
              onChange={(event, value) => setPaymentValue(value)}
            />
          </ViewInput>
          <ViewInput>
            <p>Descrição do Pagamento*</p>
            <TextArea
              rows={3}
              value={paymentDescription}
              onChange={(e) => setPaymentDescription(e.target.value)}
              placeholder="Ex: Comissão referente ao fechamento do Lead X"
            />
          </ViewInput>
        </div>
      </Modal>
    </Container>
  );
}
